//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LogoBtn from '~/components/public/logo-btn.vue';
import pagination from '~/components/public/pagination';
import allStates from '~/plugins/allStates';
export default {
  name: 'DetailsNews',
  filters: {},
  components: {
    pagination,
    LogoBtn,
    AboutStock: () => import('./about-stock'),
  },
  props: ['nordata', 'newsLabel', 'totalCount', 'newsType'],
  data() {
    return {
      page: null,
      isShowTagsFilter: true,
    };
  },
  created() {
    this.newsStates = allStates.newsStates;
    this.page = Number(this.$route.params.id);
    if (this.$route.name === 'news-page-id') {
      this.isShowTagsFilter = false;
    }
  },
  methods: {
    getMoreNews() {
      this.$emit('getMoreNews', this.newsType);
    },
  },
};
